/**
 * client/game/flags.ts — small app-shell decisions, kept pure for unit tests. OWNER: integration.
 */

/**
 * Net debug overlay visibility: off by default (a clean BO2 screen); the Options toggle turns it on and the URL
 * wins either way (`?debug=1` forces it on, `?debug=0` off).
 */
export function overlayVisible(settingOn: boolean, debugParam: string | null): boolean {
  if (debugParam === '0') return false;
  if (debugParam !== null && debugParam !== '') return true;
  return settingOn;
}
